import React from "react";
import PriceTable from "../../components/UserComponents/package/PriceTable";

const Package = () => {
  return (
    <div>
      <PriceTable />
    </div>
  );
};

export default Package;
